<!-- Alert -->
<fuse-alert
    class="fixed top-0 left-0 w-full flex justify-center items-center mt-8 alert-main z-99999"
    [type]="_alertConfig.type"
    [appearance]="'outline'"
    *ngIf="showAlert"
    [@fadeIn]="showAlert"
>
    {{ _alertConfig.message }}
</fuse-alert>

<div
    [class]="color_primario ? '' : default_color"
    [style.border]="color_primario ? color_primario + '4D' : ''"
    [style.background-color]="color_primario ? color_primario + '1A' : ''"
    class="flex items-center gap-2 p-4 border border-solid rounded-lg"
>
    <button
        mat-icon-button
        type="button"
        matTooltip="Añadir Imagen"
        [class]="color_primario ? '' : default_color"
        [style.background-color]="color_primario || ''"
        (click)="fileInput.click()"
    >
        <mat-icon class="text-white transform -rotate-45">attach_file</mat-icon>
    </button>
    <input
        #fileInput
        id="fileToUploadImagen"
        type="file"
        [accept]="validExtension"
        (change)="procesarArchivo($event)"
        class="hidden"
    />
    <small
        *ngIf="adjuntos.length === 0"
        class="text-muted cursor-pointer"
        (click)="fileInput.click()"
    >
        <b>{{ "Adjuntos" }}</b> (Max: {{ maxSize }}Mb)
        {{ text_valid_extension.replaceAll(",", ", ") }}
    </small>
    <!-- Archivos Nuevos / Guardados -->
    <div
        *ngIf="adjuntos.length > 0"
        class="w-full grid gap-2 p-2 bg-slate-200 rounded-lg max-w-full max-h-56 xl:max-h-56 sm:max-h-18 overflow-y-auto"
        style="grid-template-columns: repeat(auto-fill, minmax(200px, 1fr))"
    >
        <ng-container *ngFor="let imagen of adjuntos">
            <div
                [class]="color_primario ? '' : default_color"
                [style.background-color]="color_primario || ''"
                class="flex items-center gap-2 px-4 py-2 rounded-lg text-white"
            >
                <!-- Aquí agrego la clase truncate -->
                <span *ngIf="!imagen.idventaadjunto" class="truncate max-w-xs"
                    >{{ imagen.path }} ({{ getFileSize(imagen.size) }})</span
                >
                <a
                    *ngIf="imagen.idventaadjunto"
                    href="{{ urlBase + imagen.path }}"
                    target="_blank"
                    class="flex items-center truncate max-w-xs"
                >
                    {{ getFileNameFromUrl(imagen.path) }}
                    <mat-icon class="ml-2 text-white">open_in_new</mat-icon>
                </a>

                <button
                    mat-icon-button
                    (click)="quitarArchivo(imagen)"
                    *ngIf="!esSoloLectura"
                >
                    <mat-icon class="text-white">close</mat-icon>
                </button>
            </div>
        </ng-container>
    </div>
</div>
